export default __webpack_public_path__ + "static/11-23447e70b0c2157715c42af7e1cbc79f.webp";